module.exports = "<div class=\"log\" ng-class=\"{ 'playing': vm.sequencer.playing }\">\n  <div class=\"piano-roll\">\n    <div ng-repeat=\"row in vm.data track by $index\" class=\"piano-roll-row clearfix\">\n      <div class=\"beat\">{{row.beat || '&nbsp;'}}</div>\n      <div class=\"pitch\" ng-bind-html=\"row.pitch\"></div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/web/main/log/piano-roll.html
// module id = 170
// module chunks = 0